/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
package org.mifos.mobile.feature.loanaccount.di

import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import org.mifos.mobile.feature.loanaccount.loanAccount.LoanAccountsViewmodel
import org.mifos.mobile.feature.loanaccount.loanAccountDetails.LoanAccountDetailsViewModel
import org.mifos.mobile.feature.loanaccount.loanAccountRepaymentSchedule.RepaymentScheduleViewModel
import org.mifos.mobile.feature.loanaccount.loanAccountSummary.LoanAccountSummaryViewModel

val loanAccountModule = module {
    viewModelOf(::LoanAccountsViewmodel)
    viewModelOf(::LoanAccountDetailsViewModel)
    viewModelOf(::LoanAccountSummaryViewModel)
    viewModelOf(::RepaymentScheduleViewModel)
}
